import { SET_NAMED_PARTY_CURRENT_PAGE } from '../types';

const setCurrentPage = page => {
  return {
    type: SET_NAMED_PARTY_CURRENT_PAGE,
    payload: {
      page,
    },
  };
};

export default setCurrentPage;
